import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createBrowserRecipeAction } from '@src/app/reducers/workspace/createBrowserRecipeReducer';
import useNavigateWithSearch from '@hooks/useNavigateWithSearch';
import { selectSignedUserProfile } from '@src/app/reducers/user/userSlice';

/**
 * Invoked when the path does not contain a recipe type (browser, desktop, etc).
 * It creates a default recipe and opens it.
 */
const RecipeRouter = () => {
  const dispatch = useDispatch();
  const navigateWithSearch = useNavigateWithSearch();
  const baseRecipeCreatedRef = useRef(false);
  const { profile: userProfile } = useSelector(selectSignedUserProfile);

  useEffect(() => {
    if (!baseRecipeCreatedRef.current && userProfile) {
      baseRecipeCreatedRef.current = true;  // prevents creating the default recipe more than once
      dispatch(createBrowserRecipeAction({
        navigate: navigateWithSearch,
        user: {
          id: userProfile.id,
          firstName: userProfile.firstName,
          lastName: userProfile.lastName,
        }
      }));
    }
  }, [dispatch, navigateWithSearch, userProfile]);

  return null;
};

export default RecipeRouter;
